export default __webpack_public_path__ + "static/media/Ballroll_00041.e12b611d.png";